import Vue from 'vue';
import t from "@/service/SysMsgService";
import dictEnum from "@/constants/SysMsgDict";
import { Validator } from 'vee-validate';
export default function () {
    this.employeeTypeValidation = function(){
        const dictonary = {
          custom: {
            EmpType: {
              required: () => t.t(dictEnum.LBL_EmpType) + t.t(dictEnum.WARN_IsRequired)
            },
            CDesc: {
              required: () => t.t(dictEnum.LBL_ChiDesc) + t.t(dictEnum.WARN_IsRequired)
            },
            EDesc: {
              required: () => t.t(dictEnum.LBL_EngDesc) + t.t(dictEnum.WARN_IsRequired)
            },
          }
        };
      Validator.localize('en', dictonary);
    }   
}



// WEBPACK FOOTER //
// ./src/components/S080000-Setup/S080100-EmployeeType/S080100-EmployeeTypeValidation.js